// ** React Imports
import React from 'react'

// ** MUI Imports
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Stack from '@mui/material/Stack'
import Chip from '@mui/material/Chip'
import { styled } from '@mui/material/styles'

// Styled Card component
const StyledCard = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  border: `solid 1px ${theme.palette.grey[300]}`,
  height: '100%',
  transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[4]
  }
}))

const ConversionRateCard = ({ icon, from, to, rate }) => {  
  return (
    <StyledCard>
      <CardContent sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {icon}
            <Typography variant="h6" sx={{ color: 'common.black', fontWeight: 600 }}>
              {from} → {to}
            </Typography>
          </Box>
        </Stack>

        {/* Rate display */}
        <Box sx={{ mb: 2 }}>
          <Typography variant="h3" sx={{ color: 'common.blue', fontWeight: 700, mb: 1 }}>
            {rate.toFixed(5)}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Current exchange rate
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  )
}

export default ConversionRateCard
